import { glyphPathProps } from './glyph-path-props'
import { type IconProps, IconRoot } from './icon-root'

export type { IconProps }

/** The props of a generated icon component. The component supplies its own glyph. */
export type IconComponentProps = Omit<IconProps, 'glyph'>

/** Draws a glyph of `@gto/icons` as one `<svg>` in `currentColor`. */
export const Icon = (props: IconProps) => (
  <IconRoot {...props}>
    {props.glyph.paths.map((path) => (
      <path
        key={path.d}
        {...glyphPathProps(path, props.size)}
      />
    ))}
  </IconRoot>
)
